import ClickButton from "components/ClickButton";
import ClickHeading from "components/ClickHeading";
import FormInput from "components/Form/FormInput";
import { ThemeContext } from "contexts/Theme.context";
import { UserContext } from "contexts/User.context";
import { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import ClickLink from "components/ClickLink";
import "./Login.scss";

const Login = ({
  username,
  password,
  schoolList,
  selectSchool,
  login,
  typeUsername,
  typePassword,
  errorMessage,
}) => {
  // Remove background for this view
  const { setMainBackground } = useContext(ThemeContext);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisible = () => setPasswordVisible(!passwordVisible);

  useEffect(() => {
    setMainBackground && setMainBackground(false);
    return () => setMainBackground && setMainBackground(true);
  }, [setMainBackground]);

  // Handle authenticated user redirect
  const { id } = useContext(UserContext);

  if (id) return <Redirect to="/" />;

  return (
    <div className="LoginContainer">
      {schoolList && schoolList !== null ? (
        <form>
          <ClickHeading tag="h1">
            Selecione sua <span>escola</span>
          </ClickHeading>
          <FormInput
            type="dropdown"
            value={null}
            data={schoolList.map((school) => ({
              label: school.name,
              value: school.id,
            }))}
            onChange={selectSchool}
          />
        </form>
      ) : (
        <form
          onSubmit={(event) => {
            login(username, password);
            event.preventDefault();
          }}
        >
          <ClickHeading tag="h1">
            Faça seu <span>Login</span>
          </ClickHeading>
          <span className="error">{errorMessage}</span>
          <FormInput
            id="LoginUsername"
            label="Login"
            type="text"
            value={username}
            onChange={typeUsername}
          />
          <div className="passwordInput">
            <FormInput
              id="LoginPassord"
              label="Senha"
              type={passwordVisible ? "text" : "password"}
              value={password}
              onChange={typePassword}
            />
            <ClickButton
              fill="simple"
              className="passwordButton"
              icon={passwordVisible ? "eye-slash" : "eye"}
              label={passwordVisible ? "Esconder senha" : "Mostrar senha"}
              onClick={togglePasswordVisible}
            />
          </div>
          <ClickLink
            className="lostPassword"
            link="/esqueci-minha-senha"
          >
            Esqueci minha senha
          </ClickLink>
          <ClickButton
            type="submit"
            className="loginButton"
            color="success"
            icon="sign-in-alt"
          >
            Login
          </ClickButton>
          <ClickLink
            className="lostPassword"
            target="_blank"
            link="https://wa.me/556799777053"
            rel="noopener noreferrer"
            style={{ alignSelf: 'flex-end' }}
          >
            Ajuda com acesso
          </ClickLink>
        </form>
      )}
    </div>
  );
};

export default Login;
